import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

export const ForcePermissionModalOptions: NgbModalOptions = {
    keyboard: false,
    centered: true,
    size: 'md',
    backdrop: 'static'
  };

@Component({
  templateUrl: './force-permission.modal.html'
})
export class ForcePermissionModal {

  @Input() forPermission!: string;
  @Input() level!: string;
  @Output() forcePermissionAction: EventEmitter<boolean> = new EventEmitter();

  constructor(private activeModal: NgbActiveModal) { }

  force() {
    this.forcePermissionAction.emit();
    this.activeModal.close();
  }

  close() {
    this.activeModal.close();
  }
}
